import React from 'react';
import PropTypes from 'prop-types';
import { actionKey } from 'utils/helpers';
import { SliderWrapper, Slider } from './Styles';

const ToggleSwitch = ({ checked, onSwitchHandler, ...props }) => (
  <SliderWrapper
    onClick={onSwitchHandler}
    role="switch"
    aria-checked={checked}
    tabIndex="0"
    onKeyDown={actionKey(onSwitchHandler)}
    {...props}
  >
    <Slider
      checked={checked}
      data-cy={`toggle-switch-${checked ? 'enabled' : 'disabled'}`}
    />
  </SliderWrapper>
);

ToggleSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onSwitchHandler: PropTypes.func,
};

export default ToggleSwitch;
